import React, { useEffect, useState } from 'react';
import {
    Form,
    Input,
    Select,
    Upload,
    Avatar,
    Button,
    Alert,
} from 'antd';
import {
    UploadOutlined,
    UserOutlined,
} from '@ant-design/icons';
import axios from 'axios';

const { Option } = Select;

const provinciasConCiudades = {
    "Buenos Aires": ["La Plata", "Mar del Plata", "Bahía Blanca", "Avellaneda", "Lanús", "Lomas de Zamora", "Quilmes"],
    "Ciudad Autónoma de Buenos Aires": ["Palermo", "Recoleta", "Belgrano"],
    "Córdoba": ["Córdoba", "Villa Carlos Paz", "Río Cuarto"],
    // Agrega más provincias y ciudades si lo necesitas
};

const ActualizarClientes = ({ clienteEditando, fetchClientes, setIsModalVisible}) => {
    const [form] = Form.useForm();
    const [fileList, setFileList] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);
    const [ciudadesDisponibles, setCiudadesDisponibles] = useState([]);

    useEffect(() => {
        if (clienteEditando) {
            form.setFieldsValue(clienteEditando);
            if (clienteEditando.provincia) {
                setCiudadesDisponibles(provinciasConCiudades[clienteEditando.provincia] || []);
            }
            if (clienteEditando.avatar) {
                setPreviewImage(clienteEditando.avatar);
            }
        }
    }, [clienteEditando, form]);

    const handleFileChange = ({ fileList }) => {
        const file = fileList[0]?.originFileObj;
        if (!file) return;
        setFileList(fileList[0]);
        const reader = new FileReader();
        reader.onloadend = () => setPreviewImage(reader.result);
        reader.readAsDataURL(file);
    };

    const handleProvinciaChange = (value) => {
        form.setFieldsValue({ ciudad: undefined });
        setCiudadesDisponibles(provinciasConCiudades[value] || []);
    };

    const handleAddClient = async (values) => {
        setSubmitLoading(true);
        const token = localStorage.getItem('token');
        const usuarioId = localStorage.getItem('usuarioId');

        const formData = new FormData();
        Object.entries(values).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
                formData.append(key, value);
            }
        });
        formData.append('usuarioId', usuarioId);
        if (fileList) {
            formData.append('avatar', fileList.originFileObj);
        }

        try {
            await axios.put(`https://elarigestion-production.up.railway.app/api/editar-cliente/${clienteEditando.id}`, formData, {
                headers: {
                    Authorization: token,
                    'Content-Type': 'multipart/form-data',
                },
            });
            setSuccessMessage('Cliente actualizado correctamente');
            form.resetFields();
            setFileList(null);
            setPreviewImage(null);
            fetchClientes()
            setIsModalVisible(false)
        } catch (err) {
            const msg = err.response?.data?.message || err.message || 'Error desconocido';
            setErrorMessage(msg);
            setIsModalVisible(true)

        } finally {
            setSubmitLoading(false);
        }
    };

    return (
        <Form
            form={form}
            layout="vertical"
            onFinish={handleAddClient}
            style={{ maxWidth: 600, margin: '0 auto' }}
        >
            <Form.Item label="Foto (opcional)">
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    <Avatar size={64} src={previewImage} icon={!previewImage && <UserOutlined />} />
                    <Upload
                        accept="image/*"
                        beforeUpload={() => false}
                        showUploadList={false}
                        onChange={handleFileChange}
                        fileList={[]}
                    >
                        <Button icon={<UploadOutlined />}>Seleccionar Imagen</Button>
                    </Upload>
                    {previewImage && (
                        <Button danger onClick={() => {
                            setPreviewImage(null);
                            setFileList(null);
                        }}>
                            Eliminar
                        </Button>
                    )}
                </div>
            </Form.Item>

            <Form.Item
                label="Nombre Completo"
                name="nombre_completo"
                rules={[{ required: true, message: 'Por favor ingresa el nombre completo' }]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                label="Correo Electrónico"
                name="correo_electronico"
                rules={[{ required: true, type: 'email', message: 'Correo electrónico no válido' }]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                label="Celular"
                name="celular"
                rules={[{ required: true, message: 'Por favor ingresa un número de celular' }]}
            >
                <Input />
            </Form.Item>

            <Form.Item label="Provincia (opcional)" name="provincia">
                <Select
                    showSearch
                    placeholder="Selecciona una provincia"
                    onChange={handleProvinciaChange}
                >
                    {Object.keys(provinciasConCiudades).map((provincia) => (
                        <Option key={provincia} value={provincia}>
                            {provincia}
                        </Option>
                    ))}
                </Select>
            </Form.Item>

            <Form.Item label="Ciudad (opcional)" name="ciudad">
                <Select
                    showSearch
                    placeholder="Selecciona una ciudad"
                    disabled={!ciudadesDisponibles.length}
                >
                    {ciudadesDisponibles.map((ciudad) => (
                        <Option key={ciudad} value={ciudad}>
                            {ciudad}
                        </Option>
                    ))}
                </Select>
            </Form.Item>

            <Form.Item label="Dirección (opcional)" name="direccion">
                <Input />
            </Form.Item>

            {errorMessage && (
                <Alert
                    description={errorMessage}
                    type="error"
                    showIcon
                    closable
                    onClose={() => setErrorMessage(null)}
                    style={{ marginBottom: 16 }}
                />
            )}

            {successMessage && (
                <Alert
                    description={successMessage}
                    type="success"
                    showIcon
                    closable
                    onClose={() => setSuccessMessage(null)}
                    style={{ marginBottom: 16 }}
                />
            )}

            <Form.Item>
                <Button type="primary" htmlType="submit" loading={submitLoading} block>
                    Guardar Cliente
                </Button>
            </Form.Item>
        </Form>
    );
};

export default ActualizarClientes;
